module.exports = __webpack_public_path__ + "img/fm-f-Path 50 Copy@3x.a44cd934.png";